import { VIP_MARKET } from "@/consts";

export const canStartCampaign = (market: string | number | undefined) => {
  if (market && market !== VIP_MARKET) {
    return true;
  }
  return false;
};
